<template>
  <div class='container'
       ref="containerBox"
       @scroll="handleScroll">
    <div ref="stickyBox"
         :class="[{ sticky: isSticky }, { box: !isSticky }]"
         :style="{ background: isSticky ? '#fff' : 'transparent' }">
      <titlePage :isSticky="isSticky"
                 :scrollToTop="scrollToTop"></titlePage>
    </div>
    <div class='contentBox'>
      <div class="content">
        <div class="top-card">
          <div class="top-card-content">
            <div class="account-strip">
              <div class="account-strip__header">
                <div class="account-strip__title">账号信息</div>
                <span class="account-strip__status"
                      :class="auditStatusClass">{{ auditStatusText }}</span>
              </div>
              <div class="account-strip__grid">
                <div class="account-strip__item">
                  <span class="account-strip__label">姓名</span>
                  <span class="account-strip__value">{{ userProfile.name || '--' }}</span>
                </div>
                <div class="account-strip__item">
                  <span class="account-strip__label">手机号</span>
                  <span class="account-strip__value">{{ userProfile.tel || '--' }}</span>
                </div>
                <div class="account-strip__item">
                  <span class="account-strip__label">公司名称</span>
                  <span class="account-strip__value">{{ userProfile.company || '--' }}</span>
                </div>
                <div class="account-strip__item">
                  <span class="account-strip__label">试用到期</span>
                  <span class="account-strip__value"
                        :class="{ 'is-warning': isTrialExpiringSoon, 'is-danger': isTrialExpired }">
                    {{ trialEndDisplay }}
                  </span>
                </div>
              </div>
            </div>

            <div class="top-card-body">
              <div class="main-amount-card">
                <div class="main-amount-card__info">
                  <div class="amount-label">账户佣金金额（元）</div>
                  <div class="amount-value">{{ info.commission_amount || '0' }}</div>
                </div>
                <el-button type="primary"
                           class="withdraw-btn"
                           @click="Withdrawal">提现</el-button>
              </div>

              <div class="amount-list">
              <div class="amount-item">

                <div class="amount-item-label">
                  <div class="d1"></div>已提现（元）
                </div>
                <div class="amount-item-value">{{info.withdrawn || '0'}}</div>
              </div>
              <div class="amount-item">
                <div class="amount-item-label">
                  <div class="d2"></div>未提现（元）
                </div>
                <div class="amount-item-value">{{info.balance || '0'}}</div>
              </div>
              <div class="amount-item">
                <div class="amount-item-label">
                  <div class="d3"></div>个人佣金（元）
                </div>
                <div class="amount-item-value">{{info.personal_commission || '0'}}</div>
              </div>
              <div class="amount-item">
                <div class="amount-item-label">
                  <div class="d4"></div>团队佣金（元）
                </div>
                <div class="amount-item-value">{{info.team_commission || '0'}}</div>
              </div>
            </div>
            </div>
          </div>
        </div>

        <div class="bonus-panel flex-column">
          <div class="bonus-toolbar">
            <div class="bonus-summary">
              <div class="text bonus-summary__label">已获得奖金(元)</div>
              <div class="bonus-summary__row">
                <span class="bonus-summary__amount">{{ total_fee || 0 }}</span>
                <span class="bonus-summary__withdraw cursor"
                      @click="Withdrawal">提现</span>
              </div>
            </div>
            <el-input placeholder="请输入内容"
                      v-model="searchForm.keyword"
                      class="input-with-select bonus-toolbar__search"
                      style="border:2px solid #0092FF;border-radius: 4px;">
              <el-button slot="append"
                         icon="el-icon-search"
                         type="primary"
                         style="background: #0092FF;color: #fff;"
                         @click="search">搜索</el-button>
            </el-input>
          </div>
          <el-tabs v-model="searchForm.status"
                   @tab-click="handleClick"
                   style="margin-top: 20px;">
            <el-tab-pane label="已结算"
                         name="2"></el-tab-pane>
            <el-tab-pane label="未结算"
                         name="1"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="list-box flex-column"
             style="margin-top: 30px;"
             v-if="list.length>0">
          <div class="list-item"
               style="display: flex; flex-direction: column;padding: 0;margin-right: 0;"
               v-for="(item, index) in list"
               :key="index">
            <div class="GradientBackground flex-between"
                 style="font-size: 18px;">
              <div>
                结算单号：{{ item.order_sn || '' }}
              </div>
              <div> {{ item.status == 1 ? '未结算' : '已结算' }}</div>
            </div>
            <div class="card"
                 style="border-radius: 0 0 10px 10px;">
              <div class="flex-between">
                <div class="flex"
                     style="margin: 10px 0;">
                  <div class="tags flex-column"
                       style="padding: 0 20px;">
                    <p>公司名称</p>
                    <p v-if="item.company">{{ item.company.company || '' }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 40px;">
                    <p>职位名称</p>
                    <p v-if="item.company">{{ item.company.title || '' }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 40px;">
                    <p>姓名</p>
                    <p>{{ item.people_name || '' }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 40px;">
                    <p>结算人次</p>
                    <p>{{ item.people || 0 }}</p>
                  </div>
                  <div class="tags flex-column "
                       style="padding: 0 40px;">
                    <p>结算总额</p>
                    <p style="color: #0092FF;">{{ item.pay_fee || 0 }}</p>
                  </div>
                </div>
                <div style="margin: 10px 0;">
                  <el-button type="primary"
                             plain
                             @click="getDetails(item)">查看明细</el-button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- <div class="list-box flex-column"
             style="margin-top: 30px;"
             v-if="list.length==0">
          <div class="list-item"
               style="display: flex; flex-direction: column;align-items: center; padding: 0;margin-right: 0;">
            <div class="card">
              暂无更多 {{ list.length }}
            </div>
          </div>
        </div> -->

      </div>
    </div>
    <fotterVue></fotterVue>
    <TrialExpireRemindHost page-key="PersonalCenter" />
  </div>
</template>

<script>
import titlePage from '@/components/titlePage.vue'
import fotterVue from '@/components/fotter.vue'
import TrialExpireRemindHost from '@/components/TrialExpireRemindHost.vue'
import {
  getAuditStatusText,
  getTrialEndDisplay,
} from '@/utils/trial'
import { parseUserProfileFromIndex } from '@/utils/userProfile'

export default {
  name: '',
  components: {
    titlePage,
    fotterVue,
    TrialExpireRemindHost,
  },
  data() {
    return {
      searchForm: {
        keyword: '',
        status: '2',
        page: 1,
        size: 10,
      },
      typeList: [
        // { name: "销售人员", src: "image/index/icon1" },
        { name: '销售人员', src: 'require(`@/static/image/index/icon1.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon2.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon3.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon4.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon5.png`)' },
        { name: '销售人员', src: 'require(`@/static/image/index/icon6.png`)' },
      ],
      list: [],
      total_fee: 0,
      isSticky: false,
      info: {},
      userProfile: {},
      stickyBoxTop: 0,
    }
  },
  computed: {
    auditStatusText() {
      return getAuditStatusText(this.userProfile.audit_status)
    },
    auditStatusClass() {
      const status = this.userProfile.audit_status
      if (status === 0) return 'is-pending'
      if (status === 2) return 'is-rejected'
      return 'is-active'
    },
    trialEndDisplay() {
      return getTrialEndDisplay(
        this.userProfile.trial_end_time,
        this.userProfile.remain_days
      )
    },
    isTrialExpiringSoon() {
      const days = this.userProfile.remain_days
      return days != null && days > 0 && days <= 3
    },
    isTrialExpired() {
      const days = this.userProfile.remain_days
      return days != null && days <= 0
    },
  },
  watch: {},
  mounted() {
    this.scrollToTop()
    this.getInfo()
    this.getMyOrderpayList()
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event, this.searchForm.status);
      this.searchForm.page = 1
      this.getMyOrderpayList()
    },
    getDetails(item) {
      this.$router.push({
        path: '/SettlementDetails',
        query: {
          id: item.id,
        },
      })
    },
    getInfo() {
      this.$api.index.UserIndex().then((res) => {
        this.loading = false
        if (res.code == 200) {
          const data = res.data || {}
          this.info = data.commission_stats || {}
          this.userProfile = parseUserProfileFromIndex(data)
          if (this.userProfile.user_id) {
            localStorage.setItem('userId', String(this.userProfile.user_id))
          }
        }
      })
    },
    getMyOrderpayList() {
      if (this.searchForm.page == 1) {
        this.list = []
      }
      this.$api.index.getMyOrderpayList(this.searchForm).then((res) => {
        console.log(res, '666')
        this.loading = false
        if (res.code == 200) {
          this.list = [...this.list, ...res.data.list]
          console.log(this.list.length, 1666)
          this.isStatus = res.data.total > this.list.length ? true : false
          this.total_fee = res.data.total_fee
        }
      })
    },
    search() {
      this.searchForm.page = 1
      this.getMyOrderpayList()
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isSticky = scrollTop > this.stickyBoxTop
      const bottomOfWindow =
        this.$refs.containerBox.scrollHeight -
        this.$refs.containerBox.scrollTop -
        this.$refs.containerBox.clientHeight
      console.log(bottomOfWindow)
      if (this.isStatus == true && bottomOfWindow <= 50) {
        this.searchForm.page += 1
        this.isStatus = false
        this.getMyOrderpayList()
      }
    },
    scrollToTop() {
      this.$refs.containerBox.scrollTop = 0
    },
    Withdrawal() {
      this.$router.push({
        path: '/Withdrawal',
        query: {},
      })
    },
  },
  created() {
    this.getMyOrderpayList()
    console.log(this.list.length, 2333)
  },
}
</script>
<style lang='scss' scoped>
.contentBox {
  background: linear-gradient(0deg, #f6f8fe 0%, #f6f8fe 78%, #ceeaff 100%);
  margin-top: 60px;
  min-height: 55vh;
}

.content {
  padding: 30px 20px;
}

.account-strip {
  padding: 16px 20px 14px;
  border-bottom: 1px solid #eef2f7;
}

.account-strip__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.account-strip__title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.account-strip__status {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  line-height: 1;
}

.account-strip__status.is-active {
  color: #059669;
  background: #ecfdf5;
}

.account-strip__status.is-pending {
  color: #d97706;
  background: #fffbeb;
}

.account-strip__status.is-rejected {
  color: #dc2626;
  background: #fef2f2;
}

.account-strip__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px 20px;
}

.account-strip__label {
  display: block;
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 4px;
}

.account-strip__value {
  display: block;
  font-size: 14px;
  color: #334155;
  font-weight: 500;
  word-break: break-all;
}

.account-strip__value.is-warning {
  color: #ea580c;
}

.account-strip__value.is-danger {
  color: #dc2626;
}

@media (max-width: 900px) {
  .account-strip__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.top-card {
  border-radius: 8px;
  margin-bottom: 16px;
}

.top-card-content {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.top-card-body {
  display: flex;
  gap: 20px;
  padding: 16px 20px 20px;
}

.main-amount-card {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 20px;
  color: #fff;
  background: url('../../static/image/per_bg.png') no-repeat center center;
  background-size: 100% 100%;
  flex: 0 0 35%;
  min-width: 0;
}

.main-amount-card__info {
  min-width: 0;
  flex: 1;
}

.amount-label {
  font-size: 14px;
  color: #55719c;
  margin-bottom: 8px;
}

.amount-value {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1e202c;
}

.withdraw-btn {
  background: #0084ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 20px;
  font-size: 14px;
  flex-shrink: 0;
}

.rate-tag {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff4757;
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
}

.amount-list {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.amount-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  border-right: 1px solid #eee;

  &:last-child {
    border-right: none;
  }
}

.amount-item-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.amount-item-value {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.serchBox {
  width: 70%;
  border: 2px solid #0092ff;
  border-radius: 6px;
}

.tags {
  padding: 0 10px;
  font-weight: 400;
  font-size: 14px;
  color: #666;

  p {
    // margin: 0;
    // padding: 0;

    &:last-child {
      color: #333333;
    }
  }
}

.tagsBorder {
  border-left: 1px solid #d7d7d7;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
}

::v-deep .el-tabs__active-bar {
  background-color: transparent !important;
}

::v-deep .el-input--suffix .el-input__inner {
  padding: 23px 30px;
}

::v-deep .el-input-group__append {
  // background: rgb(42, 163, 254) !important;
  position: relative;
  width: 90px;

  .el-button {
    position: absolute;
    // top: 10px;
    // margin-top: -10px;

    top: 7px;
    right: 19px;
    height: 44px;
    width: 91px;
  }
}
.d1 {
  width: 8px;
  height: 8px;
  background: #10b981;
  border-radius: 50%;
  margin-right: 10px;
}
.d2 {
  width: 8px;
  height: 8px;
  background: #f59e0b;
  border-radius: 50%;
  margin-right: 10px;
}
.d3 {
  width: 8px;
  height: 8px;
  background: #007cff;
  border-radius: 50%;
  margin-right: 10px;
}
.d4 {
  width: 8px;
  height: 8px;
  background: #8b5cf6;
  border-radius: 50%;
  margin-right: 10px;
}

.bonus-panel {
  background: #fff;
  padding: 20px 20px 10px;
  border-radius: 8px;
}

.bonus-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
}

.bonus-summary {
  flex: 0 0 auto;
  min-width: 0;
  max-width: 42%;
}

.bonus-summary__label {
  font-size: 18px;
  margin-bottom: 8px;
}

.bonus-summary__row {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: nowrap;
  gap: 16px;
  max-width: 100%;
}

.bonus-summary__amount {
  font-size: 24px;
  font-weight: 600;
  color: #0092ff;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.bonus-summary__withdraw {
  flex-shrink: 0;
  white-space: nowrap;
  font-size: 16px;
  color: #0092ff;
  cursor: pointer;
}

.bonus-toolbar__search {
  flex: 1;
  min-width: 260px;
  max-width: 520px;
}
</style>